module.exports = __webpack_public_path__ + "static/media/gt-america-standard-regular.4d778276.woff2";